export let life = {
  mounted () {
    this.methods('setDateTimeRangeWidth')
  }
}
export let event = {
  clickSubmit (evt) {
    // 这里配合回车键审核，需要去掉el-button按钮的聚焦保持
    let target = evt.target;
    if(target.nodeName == "SPAN"){
      target = evt.target.parentNode;
    }
    target.blur();
    this.methods('clickSubmit')
  },
  clickReset (evt) {
    let target = evt.target;
    if(target.nodeName == "SPAN"){
      target = evt.target.parentNode;
    }
    target.blur();
    this.methods('clickReset')
  },
  clickExport(evt){
    let target = evt.target;
    if(target.nodeName == "SPAN"){
      target = evt.target.parentNode;
    }
    target.blur();
    this.methods('clickExport')
  },
  // 下载记录
  handleDownloadClick () {
    this.methods('handleDownloadClick')
  },
  handleDownDownloadFileClick(){
    this.methods('downloadFileClick')
  },
  handleDownloadFileAndPicClick(){
    this.methods('downloadFileAndPicClick')
  }
}
export let watch = {}
